export const isChunkLoadError = (error) => {
  const message = String(error?.message || error || '');
  const name = String(error?.name || '');

  return (
    name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Unable to preload CSS') ||
    message.includes("Unexpected token '<'") ||
    (message.includes('MIME type') && message.includes('text/html'))
  );
};
